import React, { memo, useEffect } from 'react';
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import { getMessage } from "CONFIG/i18n";
import { formatDateByLocale, getTimeInLocaleTimezone } from "UTILS/DateUtils";
import { getBootstrapTableOptions } from "UTILS/Utility";

import ic_checked from "ASSETS/Images/check.svg";

import { useSelector } from 'react-redux';
import { getSelectedLanguage } from 'REDUX/Selector/LanguageSelector';

import style from './style.module.less';

const Container = ({ supportCenterSessionsList }) => {
  const language = useSelector(getSelectedLanguage)

  return (
    <BootstrapTable 
      data={supportCenterSessionsList}
      bordered={false}
      containerClass={style.tableArea}
      tableContainerClass={style.tableContainer}
      tableHeaderClass={style.tableHeader}
      tableBodyClass={style.tableBody}
      maxHeight='380px'
      options={getBootstrapTableOptions()}
      printable
    >
      <TableHeaderColumn width="4%" dataFormat={(_, __, ___, rowIndex) => String(rowIndex + 1)}>No.</TableHeaderColumn>
      <TableHeaderColumn isKey dataSort dataField="sessionName" dataFormat={(cell) => (<div title={cell}>{cell}</div>)}>{getMessage("SESSION_NAME")}</TableHeaderColumn>
      <TableHeaderColumn width="8%" dataSort dataField="owner">{getMessage("OPERATOR")}</TableHeaderColumn>
      <TableHeaderColumn 
        width="10%"
        dataField="startTime"
        dataSort
        dataFormat={(cell) =>  (
          <div className="nameEllipsis">
            {cell ?` ${formatDateByLocale(cell, language)} ${getTimeInLocaleTimezone(cell)}` : "--"}
          </div>)
        }
      >
        {getMessage("DATE")}
      </TableHeaderColumn>
      <TableHeaderColumn width="10%" dataSort dataField="duration">{`${getMessage("DURATION")}(${getMessage("MINUTES")})`}</TableHeaderColumn>
      <TableHeaderColumn 
        width="8%"
        dataField="status"
        dataSort
        dataFormat={(cell) => getMessage(cell)}
      >
        {getMessage("STATUS")}
      </TableHeaderColumn>
      <TableHeaderColumn 
        width="10%"
        dataField="recording"
        dataSort
        dataFormat={(cell) => cell ? 
          <img
            src={ic_checked}
            className={style.recordingCheckImg}
          /> : null}
      >
        {getMessage("REPORTS_RECORDING")}
      </TableHeaderColumn>
    </BootstrapTable>
  )};

export const SessionsTable = memo(Container);
